export default "__VITE_ASSET__BKM$yZpx__"